import { Component, OnInit, TemplateRef } from '@angular/core';
import { G_CountryViewModel } from 'src/app/viewmodels/g-settings/G_CountryViewModel';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { JqHelper } from 'src/app/common/jq-helper';
import { UnitOfWorkService } from 'src/app/services/api/uow/unit-of-work.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { SaveCountryRequest } from 'src/app/viewmodels/g-settings/GSettingViewModel';

@Component({
  selector: 'app-country',
  templateUrl: './country.component.html',
  styleUrls: ['./country.component.scss']
})
export class CountryComponent implements OnInit {
  modalRef: BsModalRef;
  public vm: SaveCountryRequest;
  public brands: any = [];
  public deleteId: string;

  constructor(
    private _jq: JqHelper,
    private _uow: UnitOfWorkService,
    private _modalService: BsModalService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {
    this.getList();
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this._uow.modalServiceEx.show(template);
  }

  ngAfterViewInit() {
    // this._jq.showSpinner(true);
  }

  getList() {
    this.spinner.show();
    this._uow.gSettingService.GetCountriesAsync().subscribe((res: any) => {
      this.brands = res.result;
      console.log(res);
      this.spinner.hide();
    }, (err) => {
      console.log(err);
      this.spinner.hide();
    });
  }

  openSaveOrUpdateModel(template: TemplateRef<any>, model?) {
    this.openModal(template);
    if (model !== undefined) {
      this.vm = model;
    } else {
      this.vm = new SaveCountryRequest();
    }
  }

  openDeleteModel(template: TemplateRef<any>, model) {
    this.openModal(template);
    if (model !== undefined) {
      this.vm = model;
      this.deleteId = model.uniqueId;
    }
  }

  conformDelete() {
    this._uow.gSettingService.DeleteCountryAsync(this.deleteId).subscribe((res: any) => {
      this.getList();
      this.modalRef.hide();
    }, (err) => {
      this._jq.showSpinner();
    });
  }

  // extrnal components
  onItemSubmitted(e) {
    console.log(e);
    if (e === true) {
      this.vm = new SaveCountryRequest();
      this.getList();
    }
  }
}
